import { axios, API } from './config';

export const settingsAPI = {
  getContractTerms: async () => {
    const response = await axios.get(`${API}/settings/contract-terms`);
    return response.data;
  },
  
  updateContractTerms: async (data) => {
    const response = await axios.put(`${API}/settings/contract-terms`, data);
    return response.data;
  }
};
